import React, { useState, useEffect } from "react";
import bootstrap from "bootstrap/dist/js/bootstrap";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { api } from "../../../utils/Api";
import { useParams } from "react-router-dom";

const animatedComponents = makeAnimated();

const initial_value = {
  work_id: "",
  reason: "",
  total_files: "",
  file_path: "",
};

let myModal = {};

export default function ModalTask(props: any) {
  const [status, setStatus] = React.useState(0);
  const [close_data, SetCloseData] = useState({
    action: "close",
    data: values,
  });
  const [values, setValues] = useState(initial_value);
  const [id_value, SerIdValue] = useState(useParams());

  useEffect(() => {
    console.log("ModalTask On mount :", props);
    let myModal1 = document.getElementById("AddServiceModal");
    myModal1.addEventListener("hidden.bs.modal", function (event) {
      console.log("event :", event);
      props.close(close_data);
    });
  }, []);

  useEffect(() => {
    if (props.open) {
      console.log("ModelTask On mount :", props);

      myModal = new bootstrap.Modal(
        document.getElementById("AddServiceModal"),
        {}
      );
      myModal.show();
    }
  }, [props.open]);

  async function save_pasue() {
    console.log("Form Values :", values);

    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
      },
      post: values,
    };
    let data = await api("/outlet/service_work_pause", pass_data);
    console.log("api data :", data);
    if (data.response.status == "success") {
      let item = close_data;
      item.type = "pause";
      SetCloseData(item);
      setValues(initial_value);
      console.log("value after clear:", values);
      myModal.hide();
    }
  }

  async function save_finish() {
    console.log("Form Values :", values);

    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
      },
      post: {
        work_id: values.work_id,
        total_files: values.file_path,
        file_path: values.file_path,
      },
    };
    let data = await api("/outlet/service_work_finished", pass_data);
    console.log("api data :", data);
    if (data.response.status == "success") {
      let item = close_data;
      item.type = "finish";
      SetCloseData(item);
      setValues(initial_value);
      console.log("value after clear:", values);
      myModal.hide();
    }
  }

  function set(name: any, e: any) {
    setValues((oldValues) => ({
      ...oldValues,
      [name]: e.target.value,
      work_id: props.data.id,
    }));
    console.log("Console Set:", values);
  }

  return (
    <div
      className="modal fade"
      id="AddServiceModal"
      tabIndex={-1}
      aria-labelledby="ModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            {props.type == "pause" ? (
              <h5 className="  modal-title" id="ModalLabel">
                Pasue Details
              </h5>
            ) : (
              ""
            )}
            {props.type == "finish" ? (
              <h5 className="  modal-title" id="ModalLabel">
                Finish Details
              </h5>
            ) : (
              ""
            )}
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <div>
              <p>
                <small>Please fill a correct details</small>
              </p>
              <div className="mt-3">
                <form className="g-3">
                  {/* onSubmit={onSubmit} */}

                  {props.type == "pause" ? (
                    <div className="row">
                      {props.data.quantity_type == 1 ? (
                        <div className="col-md-6">
                          <label className="form-label">
                            Total Worked Items
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            defaultValue={values.total_files}
                            required
                            onChange={(e) => {
                              set("total_files", e);
                            }}
                          />
                        </div>
                      ) : (
                        <div className="col-md-6">
                          <label className="form-label">
                            Total Worked Durations <small>(in minutes)</small>{" "}
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            defaultValue={values.total_files}
                            required
                            onChange={(e) => {
                              set("total_files", e);
                            }}
                          />
                        </div>
                      )}
                      <div className="col-md-6">
                        <label className="form-label">Reason for pause</label>
                        <input
                          type="text"
                          className="form-control"
                          defaultValue={values.reason}
                          required
                          onChange={(e) => {
                            set("reason", e);
                          }}
                        />
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">Edited file path</label>
                        <input
                          type="text"
                          className="form-control"
                          defaultValue={values.file_path}
                          required
                          onChange={(e) => {
                            set("file_path", e);
                          }}
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="row">
                      {props.data.quantity_type == 1 ? (
                        <div className="col-md-6">
                          <label className="form-label">
                            Total Worked Items
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            defaultValue={values.total_files}
                            required
                            onChange={(e) => {
                              set("total_files", e);
                            }}
                          />
                        </div>
                      ) : (
                        <div className="col-md-6">
                          <label className="form-label">
                            Total Worked Durations <small>(in minutes)</small>{" "}
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            defaultValue={values.total_files}
                            required
                            onChange={(e) => {
                              set("total_files", e);
                            }}
                          />
                        </div>
                      )}

                      <div className="col-md-6">
                        <label className="form-label">Edited file path</label>
                        <input
                          type="text"
                          className="form-control"
                          defaultValue={values.file_path}
                          required
                          onChange={(e) => {
                            set("file_path", e);
                          }}
                        />
                      </div>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light-outline"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                myModal.hide();
              }}
            >
              Close
            </button>
            <button
              type="button"
              className="btn btn-light-outline"
              onClick={() => {
                if (props.type == "pause") {
                  console.log("pause");
                  save_pasue();
                } else {
                  console.log("finish");
                  save_finish();
                }
              }}
            >
              Save changes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
